import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Taaha Kamal
        </p>
        <a
          className="App-link"
          href="https://LinkedIn.com/in/taaha-kamal"
          target="_blank"
          rel="noopener noreferrer"
        >
        	LinkedIn
        </a>
        <a
          className="App-link"
          href="https://drive.google.com/file/d/16ZIXGDzHgIGzTs2IoAtJlzv9uhLIlAQM/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
        	Resume
        </a>
      </header>
    </div>
  );
}

export default App;
